import { Language, TText } from "api/type";
import { LanguageContext, ThemeContext } from "contexts";
import React from "react";

type PoweredByClinicOSProps = {};

const translate: TText = {
  poweredBy: {
    en: "Powered by",
    es: "Desarrollado por ",
  },
};

const PoweredByClinicOS: React.FC<PoweredByClinicOSProps> = () => {
  const theme = React.useContext(ThemeContext);
  const language = React.useContext<Language>(LanguageContext)[0];

  return (
    <div style={styles.container}>
      <p style={styles.text}>
        {translate.poweredBy[language]}{" "}
        <a
          href="https://clinicos.ai"
          target="_blank"
          rel="noopener noreferrer"
          style={{ ...styles.link, color: theme?.themeColor ?? "#00B7F4" }}
        >
          ClinicOS
        </a>
      </p>
    </div>
  );
};

const styles = {
  container: {
    margin: "0 auto",
  },
  text: {
    fontWeight: 400,
    fontSize: "12px",
    color: "#646B6C",
  },
  link: {
    textDecoration: "none",
  },
} as const;

export default PoweredByClinicOS;
